<template>
  <span>
    {{broker.company}}: {{broker.username}} {{broker.lastname}}
  </span>

</template>

<script>
import db from './fireBaseInit'
export default {
  data () {
    return {
      broker: {}
    }
  },
  props: ['brokerID'],
  firestore () {
    return {
    }
  },
  watch: {
    brokerID: function () {
      this.$bind('broker', db.collection('users').doc(this.brokerID))
        .then((doc) => {
          return null
        })
        .catch((error) => {
          console.log('error in loading: ', error)
        })
    }
  },
  mounted: function () {
    this.$bind('broker', db.collection('users').doc(this.brokerID))
      .then((doc) => {
        // do nothing special
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  computed: {
    fullname: function () {
      return this.broker.username
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BrokerName.vue